import { Component, OnInit } from '@angular/core';
import { QuickbooksService } from '../quickbooks.services';
import { Store, select } from '@ngrx/store';
import { combineLatest } from 'rxjs';
import * as fromCompanySettings from '../../company-setting/store';
import * as fromqb from '../store';
import { CompanySettingService } from '../../company-setting';
import { LoggingService } from '../../shared/services/logging';
import { takeWhile } from 'rxjs/operators';

@Component({
    selector: 'ef-quick-books-connect',
    templateUrl: './quick-books-connect.component.html',
    styleUrls: ['./quick-books-connect.component.scss'],
    standalone: false
})
export class QuickBooksConnectComponent implements OnInit {
    private isActive = true;
    public message: string;
    constructor(
        private service: QuickbooksService,
        private settingService: CompanySettingService,
        private log: LoggingService,
        private store: Store
    ) {}
    ngOnDestroy(): void {
        this.isActive = false;
    }

    ngOnInit(): void {
        // this.settingService
        //     .getSetting('QuickbooksOnline')
        //     .toPromise()
        //     .then(qbo => {
        //         this.log.verbose({
        //             type: 'QuickBooksConnectComponent',
        //             qbo
        //         });
        this.service
            .GetAuthUrl()
            .toPromise()
            .then(authUrl => {
                this.log.verbose({
                    type: 'QuickBooksConnectComponent',
                    authUrl
                });
                if (authUrl && !(window as any).__karma__) {
                    window.location.href = authUrl;
                }
            });
        // })
        // .catch(err => {
        //     this.message = `An error has occured: ${err}`;
        // });
    }
}
